import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import { UserPermissionType } from '@/features/permissions/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/users',
  }),
  tagTypes: ['UserPermissions'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getUserPermissions: builder.query<UserPermissionType[], void>({
      query: () => ({
        url: `/permissions`,
      }),
      providesTags: ['UserPermissions'],
    }),
  }),
});

export const { useGetUserPermissionsQuery } = permissionsApi;
